const STORAGE_PREFIX = 'argusModernNavigationGroups';
const SIDEBAR_COLLAPSED_STORAGE_PREFIX = 'argusModernSidebarCollapsed';
export const DESKTOP_SIDEBAR_COLLAPSE_REQUEST_EVENT =
    'argus:desktop-sidebar-collapse-request';

function storageKey(user, prefix = STORAGE_PREFIX) {
    if (!user) return null;
    const company = user.company || 'company';
    const userId = user.userId || user.user_id || user.id || 'user';
    return `${prefix}:${company}:${userId}`;
}

export function getOpenNavigationGroups(user) {
    const key = storageKey(user);
    if (!key || typeof window === 'undefined' || !window.localStorage) {
        return [];
    }
    try {
        const parsed = JSON.parse(window.localStorage.getItem(key) || '[]');
        return Array.isArray(parsed)
            ? parsed.filter(value => typeof value === 'string' && value)
            : [];
    } catch (error) {
        return [];
    }
}

export function saveOpenNavigationGroups(user, groupKeys) {
    const key = storageKey(user);
    if (!key || typeof window === 'undefined' || !window.localStorage) {
        return;
    }
    const normalized = Array.from(new Set(
        (Array.isArray(groupKeys) ? groupKeys : [])
            .filter(value => typeof value === 'string' && value)
    ));
    try {
        window.localStorage.setItem(key, JSON.stringify(normalized));
    } catch (error) {
        // Navigation state is a local convenience and must never block the app.
    }
}

export function getDesktopSidebarCollapsed(user) {
    const key = storageKey(user, SIDEBAR_COLLAPSED_STORAGE_PREFIX);
    if (!key || typeof window === 'undefined' || !window.localStorage) {
        return false;
    }
    try {
        return window.localStorage.getItem(key) === '1';
    } catch (error) {
        return false;
    }
}

export function saveDesktopSidebarCollapsed(user, collapsed) {
    const key = storageKey(user, SIDEBAR_COLLAPSED_STORAGE_PREFIX);
    if (!key || typeof window === 'undefined' || !window.localStorage) {
        return;
    }
    try {
        if (collapsed) {
            window.localStorage.setItem(key, '1');
        } else {
            window.localStorage.removeItem(key);
        }
    } catch (error) {
        // Navigation state is a local convenience and must never block the app.
    }
}

export function requestDesktopSidebarCollapsed(collapsed, options = {}) {
    if (
        typeof window === 'undefined' ||
        typeof window.CustomEvent !== 'function'
    ) {
        return;
    }
    window.dispatchEvent(new window.CustomEvent(
        DESKTOP_SIDEBAR_COLLAPSE_REQUEST_EVENT,
        {
            detail: {
                collapsed: collapsed === true,
                temporary: options.temporary === true
            }
        }
    ));
}
